export default __webpack_public_path__ + "static/media/verified-icon-silver.ef2942a5.svg";